/* Free-gift cart bar: add gift/upsell items, and auto-remove the gift below the threshold.
   Loaded globally (layout) so it also works with the dynamically-rendered cart drawer. */
(function () {
  if (window.__giftBarGuard) return;
  window.__giftBarGuard = true;

  var THRESHOLD = 15000; // cents ($150)
  var GIFT_HANDLE = 'free-gift';
  var busy = false;

  // Re-render the cart regions from a fresh page fetch. Used after raw cart mutations
  // (variant swap) that bypass the theme's own cart store, so the drawer stays in sync.
  function refreshCart() {
    return fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Match the Nth current element to the Nth fresh element sharing an id, so duplicate
        // xo-unique-ids on the /cart page (drawer + page both render the gift bar) don't cross-contaminate.
        var seen = {};
        document.querySelectorAll('[xo-unique-id]').forEach(function (cur) {
          var id = cur.getAttribute('xo-unique-id');
          if (!id || !/cart|gift/i.test(id)) return;
          var esc = id.replace(/"/g, '');
          var idx = seen[esc] == null ? 0 : seen[esc] + 1;
          seen[esc] = idx;
          var list = doc.querySelectorAll('[xo-unique-id="' + esc + '"]');
          var fresh = list[idx] || list[0];
          if (fresh) cur.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {});
  }

  // "Add Power Bank" -> switch the No-Powerbank backpack line to the Add-Powerbank variant
  // (remove the old line + add the powerbank variant in one atomic /cart/update.js call).
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pb-swap]');
    if (!b) return;
    e.preventDefault();
    var target = b.getAttribute('data-pb-swap');
    if (!target) return;
    b.setAttribute('disabled', '');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var noPB = (cart.items || []).filter(function (i) {
          return i.handle === 'led-backpack' && /no\s*powerbank/i.test(i.variant_title || '');
        });
        if (!noPB.length) { b.removeAttribute('disabled'); return; }
        var swapQty = noPB.reduce(function (s, l) { return s + l.quantity; }, 0);
        var existing = (cart.items || []).filter(function (i) {
          return String(i.variant_id) === String(target);
        }).reduce(function (s, l) { return s + l.quantity; }, 0);
        var updates = {};
        noPB.forEach(function (l) { updates[l.key] = 0; });
        updates[target] = existing + swapQty;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return refreshCart(); });
      })
      .catch(function () { b.removeAttribute('disabled'); });
  });

  // Enforce the gift rules server-side:
  //  - remove the gift entirely if the cart drops below the threshold
  //  - never allow more than ONE free gift per order
  function guard() {
    if (busy) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = (cart.items || []).filter(function (it) { return it.handle === GIFT_HANDLE; });
        if (!gifts.length) return;
        var totalQty = gifts.reduce(function (s, l) { return s + l.quantity; }, 0);
        var updates = null;
        if (cart.total_price < THRESHOLD) {
          // below threshold -> drop the gift
          updates = {};
          gifts.forEach(function (l) { updates[l.key] = 0; });
        } else if (totalQty > 1) {
          // limit to a single free gift: keep one, remove the rest
          updates = {};
          gifts.forEach(function (l, i) { updates[l.key] = i === 0 ? 1 : 0; });
        }
        if (!updates) return;
        busy = true;
        // Reload after a corrective mutation: the theme edits cart lines by index and drives
        // the header count from its own store, so a raw update must fully re-sync (not just swap HTML).
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { busy = false; });
      })
      .catch(function () {});
  }

  // Re-check after any cart mutation (the theme also re-renders the cart on these).
  var origFetch = window.fetch;
  window.fetch = function (u) {
    var pr = origFetch.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (url.indexOf('/cart/') > -1 && url.indexOf('/cart.js') === -1) {
        pr.then(function () { setTimeout(guard, 250); });
      }
    } catch (e) {}
    return pr;
  };

  if (document.readyState !== 'loading') { setTimeout(guard, 500); }
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(guard, 500); });
})();
